var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.808,
    height: 11.808,
    viewBox: "0 0 11.808 11.808",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "comment",
    d: "M7.3,14.82,5.812,16.308V13.58a5.369,5.369,0,0,1-1.312-3.5A5.747,5.747,0,0,1,10.4,4.5a5.747,5.747,0,0,1,5.9,5.576,5.747,5.747,0,0,1-5.9,5.576,6.135,6.135,0,0,1-3.1-.832Z",
    transform: "translate(-4.5 -4.5)",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.5cc40fb13979ccdb381e95e7c13a349c.svg";
export { ForwardRef as ReactComponent };